import classNames from "classnames";
import { Stack } from "PFComponents/containers";

import css from "./modal_layout.module.scss";
import { ModalLayoutFooter, ModalLayoutFooterProps } from "./modal_layout_footer";
import { ModalLayoutHeader, ModalLayoutHeaderProps } from "./modal_layout_header";

export type ModalLayoutProps = {
  children?: React.ReactNode;
  classes?: {
    body?: string;
  };
} & ModalLayoutHeaderProps &
  ModalLayoutFooterProps;

export const ModalLayout = ({
  title,
  subtitle,
  children,
  classes = {},
  onOK,
  onCancel,
  labelOK,
  kindOK,
  showOKButton = true,
  disableOKButton = false,
  ariaLabelOK,
  buttonOKType,
  buttonOKFormId,
  labelCancel,
  footerLabel,
  showCancelButton = true,
  ariaLabelCancel,
  showSecondaryButton = false,
  secondaryButtonLabel,
  closeOnOK = true,
  onSecondaryButtonClick
}: ModalLayoutProps) => (
  <Stack gap={null} className={css.layout}>
    <ModalLayoutHeader title={title} subtitle={subtitle} />
    <main className={classNames(css.body, classes.body)}>{children}</main>
    <ModalLayoutFooter
      labelOK={labelOK}
      kindOK={kindOK}
      showOKButton={showOKButton}
      disableOKButton={disableOKButton}
      ariaLabelOK={ariaLabelOK}
      buttonOKType={buttonOKType}
      buttonOKFormId={buttonOKFormId}
      labelCancel={labelCancel}
      footerLabel={footerLabel}
      showCancelButton={showCancelButton}
      ariaLabelCancel={ariaLabelCancel}
      showSecondaryButton={showSecondaryButton}
      secondaryButtonLabel={secondaryButtonLabel}
      closeOnOK={closeOnOK}
      onSecondaryButtonClick={onSecondaryButtonClick}
      onOK={onOK}
      onCancel={onCancel}
    />
  </Stack>
);
